import { Component } from '@angular/core';


@Component({
    selector: 'app-riesgo',
    templateUrl: './riesgo.component.html',
    styleUrls: ['./riesgo.component.css']
})
export class RiesgoComponent  {


}
